import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IconRegistryService } from '@app-core/providers/icon-registry.service';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '@shared/material/material.module';
import { SharedModule } from '@shared/shared.module';
import { AccesRestrictedComponent } from './components/acces-restricted/acces-restricted.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    MaterialModule,
    TranslateModule,
    SharedModule
  ],
  declarations: [
    NavbarComponent,
    SidebarComponent,
    NotFoundComponent,
    AccesRestrictedComponent
  ],
  providers: [
    IconRegistryService
  ],
  exports: [
    NavbarComponent,
    SidebarComponent,
    NotFoundComponent,
    MaterialModule,
  ]
})

export class CoreModule {
}
